// config.js
const BASE_URL = "https://api.shipclues.in/";

export const config = {
  authentication: {
    signIn: `${BASE_URL}api/v1/admins/admin/login/`,
    signUp: `${BASE_URL}api/v1/admins/admin/register/`,
    loginWithOtp: `${BASE_URL}api/v1/admins/admin/login-with-otp/`,
    loginVerifyOtp: `${BASE_URL}api/v1/admins/admin/login-verify-otp/`,
  },

  profile: {
    info: `${BASE_URL}api/v1/admins/admin/profile/`,
  },

  dashboard: {
    count: `${BASE_URL}api/v1/admins/analytics/orders/daily-status-count/`,
    /** Per-seller daily created/shipped rows.
     * Path is relative — use with axios (`baseURL` already includes `/api/v1`).
     * Query params: `from_date`, `to_date`, optional `search`, `sort_by`, `sort`. */
    dailyOrderCount: "/admins/analytics/orders/daily-order-count/",
    onboarding: `${BASE_URL}api/v1/admins/sellers/user-count/`,
  },

  admin_user: {
    list: `${BASE_URL}api/v1/admins/all/users/profile/`,
    // Legacy permissions (still kept for backward compatibility)
    permissions: (id) =>
      `${BASE_URL}api/v1/admins/views/${id}/permission-matrix/`,
    update: (id) => `${BASE_URL}api/v1/admins/user/profile/${id}/update/`,
    createStats: `${BASE_URL}api/v1/admins/user-register/`,
    createSuper: `${BASE_URL}api/v1/admins/superuser-register/`,
    updatePermissions: (id) =>
      `${BASE_URL}api/v1/admins/update/${id}/permission-sync/`,
    // New UI permissions APIs (GET / PUT) for Admin/Employee UI access
    
    uiPermissions: `${BASE_URL}api/v1/admins/login-user/ui-permissions/`,   
    //update permission api
    permissionupdate: `${BASE_URL}api/v1/admins/users/ui-permissions/`,
    
  },

  sellers: {
    list: `/admins/sellers-list/`,
    // Admin full URL (preferred for authenticated axiosInstance usage)
    admin_list: `${BASE_URL}api/v1/admins/sellers-list/`,
    // Full list without pagination for dropdowns
    admin_list_all: `${BASE_URL}api/v1/admins/sellers-list/all/`,
    // Lightweight seller rows (e.g. dropdowns); use when full `admin_list` is too heavy
    admin_list_basic: `${BASE_URL}api/v1/admins/seller-list/basic/`,
    basic_info: `/admins/company-details/`,
    account_info: `/admins/bank-details/`,
    kyc_info: `/admins/kyc-documents/`,
    kyc_document: `/admins/kyc-document/`,
    verify_company: `/admins/verify-company/`,
    verify_bank: `/admins/verify-bank/`,
    verify_account: `/admins/verify-account/`,
    verify_kyc: `/admins/verify-kyc-document/`,
    verify_kyc_document: `/admins/verify-kyc-document/`,
    /** Verify seller (agreement / overall) */
    verify_seller: (id) => `/admins/verify-seller/${id}/`,
    /** Seller agreement commercial terms (GET/POST/PATCH by seller) */
    agreement: `/admins/seller-agreement/`,
    agreement_detail: (id) => `/admins/seller-agreement/${id}/`,
  },
  billing: {
    freight_invoices_export: `${BASE_URL}api/v1/admins/freight-invoices/export/`,
    // SMS Invoice APIs
    sms_invoices_list: `${BASE_URL}api/v1/admins/vas-invoices/sms/list/`,
    sms_export: `${BASE_URL}api/v1/admins/notification-invoices/export/`,
    sms_invoice_download: (invoiceId) => `${BASE_URL}api/v1/admins/notification-invoices/${invoiceId}/download/`,
    // ECOD Invoice APIs
    ecod_invoices_list: `${BASE_URL}api/v1/admins/vas-invoices/ecod/list/`,
    ecod_export: `${BASE_URL}api/v1/admins/early-cod-invoices/export/`,
    ecod_invoice_download: (invoiceId) => `${BASE_URL}api/v1/admins/early-cod-invoices/${invoiceId}/download/`,
  },
  orders: {
    // Updated to use the new order-report export endpoint
    //report: `${BASE_URL}api/v1/admins/order-report/export/`,
    // Unmasked UI sends `{ params, unmasked: true }` on POST and `unmasked=true` on AWB GET — align keys with your API.
    report: `${BASE_URL}api/v1/admins/order-export/request/`,
    report_headers: `${BASE_URL}api/v1/admins/order-export/headers/`,
    report_masked: `${BASE_URL}api/v1/admins/order-export/request/masked/`,
    bulk_export: `${BASE_URL}api/v1/admins/upload-awb-csv/export/`,
    awb_export: `${BASE_URL}api/v1/admins/export/orders/shipments/`,
  },
  vas: {
    // Legacy endpoints - use billing.sms_invoices_list and billing.ecod_invoices_list instead
    sms_invoices_list: `${BASE_URL}api/v1/admins/vas-invoices/`,
    sms_invoices: `${BASE_URL}api/v1/admins/vas-invoices/`,
    ecod_invoices: `${BASE_URL}api/v1/admins/vas-invoices/`,
  },

  logistics: {
    partner_list: `${BASE_URL}api/v1/admins/partners/`,
    detail: `${BASE_URL}api/v1/admins/partners/`,
    edit: `${BASE_URL}api/v1/admins/partners/`,
  },

  plan: {
    plan_list: `${BASE_URL}api/v1/admins/plans/`,
  },

  early_cod: {
    ecod_list: `${BASE_URL}api/v1/admins/early-cod/`,
    create_ecod: `${BASE_URL}api/v1/admins/early-cod/`,
    update_ecod: `${BASE_URL}api/v1/admins/early-cod/`,
  },

  wallet_history: {
    wallet_list: `${BASE_URL}api/v1/admins/wallet/export/history/`,
  },

  seller_recharge: {
    recharge_list: `${BASE_URL}api/v1/admins/wallet/export/recharges/`,
  },

  // wallet_history: {
  //   wallet_list: `${BASE_URL}api/v1/admins/wallet/export/history/`,
  // },

  manual_wallet: {
    recharge: `${BASE_URL}api/v1/admins/wallet/manual-recharge/`,
    // send_otp: `${BASE_URL}api/v1/admins/wallet/manual-recharge/`,
  },

  finance: {
    SellerShippingRate: `${BASE_URL}api/v1/admins/view/seller-rates/`,
    SellerShippingRateExport: `${BASE_URL}api/v1/admins/view/seller-rates/export/`,
    SellerShippingRateSample: `${BASE_URL}api/v1/admins/download-seller-rate-card-sample/`,
    SellerShippingRateUpload: `${BASE_URL}api/v1/admins/upload-seller-rate-cards/`,
    SellerShippingRateUpdate: `${BASE_URL}api/v1/admins/seller-courier-rate/`,
    export: {
      cod_remittance:
        "https://api.shipclues.in/api/v1/finance/export/cod-remittance/",
    },
  },

  weight_discrepancy: {
    import: `${BASE_URL}api/v1/admins/weight-reconciliation/import-csv/`,
    import_sample_csv: `${BASE_URL}api/v1/admins/weight-reconciliation/import-sample-csv/`,
    list: `${BASE_URL}api/v1/admins/weight-reconciliation/`,
    disputes: `${BASE_URL}api/v1/admins/weight-reconciliation/disputes/`,
    dispute_detail: (id) =>
      `${BASE_URL}api/v1/admins/weight-reconciliation/disputes/${id}/`,
    reconciliation_detail: (id) =>
      `${BASE_URL}api/v1/admins/weight-reconciliation/${id}/`,
    dispute_accept: (id) =>
      `${BASE_URL}api/v1/admins/weight-reconciliation/${id}/accept/`,
    dispute_reject: (id) =>
      `${BASE_URL}api/v1/admins/weight-reconciliation/${id}/reject/`,
    bulk_accept: `${BASE_URL}api/v1/admins/weight-reconciliation/bulk-accept/`,
    bulk_reject: `${BASE_URL}api/v1/admins/weight-reconciliation/bulk-reject/`,
    export: `${BASE_URL}api/v1/admins/export-weight-discrepancy/`,
    weight_upload_history: `${BASE_URL}api/v1/admins/weight-reconciliation/weight-upload-history/`,
    weight_upload_logs: (id) => `${BASE_URL}api/v1/admins/weight-reconciliation/weight-upload-history/${id}/logs/`,
    weight_upload_export_csv: (id) => `${BASE_URL}api/v1/admins/weight-reconciliation/weight-upload-history/${id}/export-csv/`,
    sorter_image: `${BASE_URL}api/v1/admins/sorter-image/`,
    sorter_image_export: `${BASE_URL}api/v1/admins/sorter-image/export-csv/`,
  },
  cod_remittance: {
    list: `${BASE_URL}api/v1/admins/cod-remittance/`,
    mark_paid_import: `${BASE_URL}api/v1/admins/cod-remittance-import/mark-paid/`,
    pending: `${BASE_URL}api/v1/admins/cod-remittance/pending/`,
    pending_export: `${BASE_URL}api/v1/admins/cod-remittance/pending/export/`,
    logs: `${BASE_URL}api/v1/admins/cod-remittance/logs/`,
    logs_error_export: `${BASE_URL}api/v1/admins/cod-remittance/logs/error-export/`,
  },

  employees: {
    list: `${BASE_URL}api/v1/admins/admin-employees/`,
    detail: (id) => `${BASE_URL}api/v1/admins/admin-employees/${id}/`,
    /** GET permission catalog — relative path for axiosInstance (baseURL /api/v1). */
    employeePermissions: `/admins/admin-employee-permissions/`,
    employeePermissionsFull: `${BASE_URL}api/v1/admins/admin-employee-permissions/`,
    /** GET assigned sellers for an admin employee */
    sellersAssigned: (id) =>
      `/admins/admin-employees/${id}/sellers/`,
    assignSellers: (id) =>
      `/admins/admin-employees/${id}/assign-sellers/`,
    removeSellers: (id) =>
      `/admins/admin-employees/${id}/remove-sellers/`,
    /** multipart CSV — backend defines columns (often employee ↔ seller mappings) */
    assignSellersCsv: `/admins/admin-employees/assign-sellers-csv/`,
  },

  /** HOD roster: GET list, GET `?department=`, POST create with `?department=` */
  hodEmployees: {
    list: `${BASE_URL}api/v1/admins/admin-hod-employees/`,
    detail: (id) => `${BASE_URL}api/v1/admins/admin-hod-employees/${id}/`,
  },

  // Admin Reports - Async Order Export APIs
  admin_reports: {
    list: `${BASE_URL}api/v1/admins/order-export/list/`,
    list_masked: `${BASE_URL}api/v1/admins/order-export/list/masked/`,
    download: `${BASE_URL}api/v1/admins/order-export/download-url/`,
    downloadDirect: `${BASE_URL}api/v1/admins/order-export/download/`,
  },

  // Technologies APIs
  technologies: {
    serviceability_check: `${BASE_URL}api/v1/admins/serviceability/`,
  },

  /** Company-level seller performance (D/L, In-Transit, RTO, NDR).
   * Query params: `from_date`, `to_date`, optional `seller_codes` (comma separated). */
  seller_performance: {
    list: `${BASE_URL}api/v1/admins/analytics/sellers/performance/`,
  },

  dispute_records: {
    list: `${BASE_URL}api/v1/admins/dispute-records/`,
    create: `${BASE_URL}api/v1/admins/dispute-records/`,
    export: `${BASE_URL}api/v1/admins/dispute-records/export/`,
    download: `${BASE_URL}api/v1/admins/dispute-records/download/`,
    detail: (id) => `${BASE_URL}api/v1/admins/dispute-records/${id}/`,
    update: (id) => `${BASE_URL}api/v1/admins/dispute-records/${id}/`,
    delete: (id) => `${BASE_URL}api/v1/admins/dispute-records/${id}/`,
  },
};

export default config;
